import { Component, OnInit, EventEmitter, Output, Input, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../services/storage.service';
import { ConsultaService } from '../../services/consulta.service';

@Component({
  selector: 'app-modal-request',
  templateUrl: './modal-request.component.html',
  styleUrls: ['./modal-request.component.scss'],
})
export class ModalRequestComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() title: string;
  @Input() text: any;
  @Output() fecharModal = new EventEmitter();
  estabelecimento: any;
  pdfs: Array<any> = [];
  imagens: Array<any> = [];
  cnesConsulta;
  credenciais = [];
  est: any;
  config: any;

  solicitacao = {
      anoSolicitacao : 0,
      base64Anexo: "",
      cpfUsuarioSolicitante: "",
      noUsuarioSolicitante: "",
      justificativaSolicitacao: "",
      numeroSolicitacao: 0
  }

  constructor(private toast: ToastrService,
    private api: ApiService,
    private loading: NgxSpinnerService,
    private toastService: ToastrService,
    private consulta: ConsultaService,
    private ngZone: NgZone,
    private storage: StorageService) {
    }

  ngOnInit() {
    this.loadUser();
  }

  async loadUser() {
    let user = this.storage.getUserBc();
    this.solicitacao.cpfUsuarioSolicitante = user.cpf;
    this.solicitacao.noUsuarioSolicitante = user.nome;
  }

  fechar() {
    this.fecharModal.emit();
  }

  adicionar() {
    this.fecharModal.emit();
  }

  async handleFileSelected(data: any) {
    try {
      await this.ngZone.run(() => {
        data.arquivo.id = Date.now();
        if (data.isImagem) {
          this.imagens.push(data.arquivo);
        } else {
          this.pdfs.push(data.arquivo);
        }
      });
    } catch ( e ) {
      console.log(e);
      this.toastService.error('Erro ao anexar o arquivo');
    }
  }

  async handelFileExcluded(data: any) {
    try {
      if (data.isImagem) {
        this.imagens.splice(data.index, 1);
      } else {
        this.pdfs.splice(data.index, 1);
      }
    } catch ( e ) {
      console.log(e);
      this.toastService.error('Erro ao remover o anexo');
    }
  }

  async consultar() {
    if (this.cnesConsulta) {
        if (this.cnesConsulta) {

          this.loading.show();
          this.est = await this.consulta.consultarEstabelecimentoPorCNES(this.cnesConsulta);
          this.credenciais = await this.consulta.consultarEstabelecimentoPorCredenciais(this.cnesConsulta);
          if (this.est) {
            this.estabelecimento = {
              sucesso: true,
              codigoCNES: this.est.codigoCNES,
              nomeFantasia: this.est.nomeFantasia,
              ddTelefone: this.est.ddTelefone,
              cep: this.est.cep,
              descricaoEndereco: this.est.descricaoEndereco,
              descricaoBairro: this.est.descricaoBairro,
              nomeMunicipio: this.est.nomeMunicipio,
              siglaUF: this.est.siglaUF,
              nomeEmpresarial: this.est.dsTipoUnidade,
              codigoMunicipio: this.est.coMunicipioIbge,
              codigoUF: this.est.siglaUF,
              codigoUnidade: this.est.coTipoUnidade,
              mensagens: [''],
              numeroCNPJ: '',
              numero: '',
              numTelefone: this.est.numTelefone,
              email: this.est.email
            };
            this.loading.hide();
          }
        }
    } else {
      this.toast.error('Preencha o campo CNES ou CNPJ');
    }
  }

  async solicitar() {
    if (this.imagens.length > 0 ) {
      let baseimg = this.imagens[0].src
      this.solicitacao.base64Anexo = baseimg;
    }
    if (this.pdfs.length > 0 ) {
      let base = this.pdfs[0].src;
      this.solicitacao.base64Anexo = base;
    }

    if (!this.solicitacao.numeroSolicitacao) {
      this.toast.error('Selecione uma credencial');
      return;
    }

    if (!this.solicitacao.base64Anexo) {
      this.toast.error('Preencha o campo Anexo');
      return;
    }

    if (!this.solicitacao.justificativaSolicitacao) {
      this.toast.error('Preencha o campo justificativa');
      return;
    }

    let ano = this.credenciais.find((data) => data.numeroSolicitacao == this.solicitacao.numeroSolicitacao).anoSolicitacao;
    this.solicitacao.anoSolicitacao = ano;

    this.loading.show();

  let alteracao = await this.consulta.enviarSolicitacao(this.solicitacao);
    console.log(alteracao);
    if (alteracao.status == 'S') {
      this.toast.success('Solicitação enviada com sucesso');
      this.fechar();
    } else {
      this.toast.error('Erro ao enviar a solicitação');
    }

    this.loading.hide();

    console.log(this.solicitacao)
  }

  tratarEmailSolicitante(){

  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-request/modal-request.component.ts